import { useCallback } from 'react';

import { ITranslateMethod } from '@core/js/hooks/i18n/types';
import validationMethods from '@core/js/utils/Validation/validationMethods';

import { ADDRESS_FIELDS } from '@interlayer/js/app/components/main/Registration/components/templates/OnlineReg/components/RegInSteps/components/common/steps/AddressStep/constants';

import { getValidationRules } from '../utils/validationRules';

import { useCheckCities } from './useCheckCities';
import { useCheckZips } from './useCheckZips';

export const useCheckSearchAddress = (t: ITranslateMethod) => {
    const checkZips = useCheckZips(t);
    const checkCities = useCheckCities(t);

    return useCallback((_: string, __: unknown, values: Record<string, string>) => {
        const validationRules = getValidationRules(t);

        const customFieldValidation = {
            zip: checkZips,
            city: checkCities
        };

        for (let index = 0; index < ADDRESS_FIELDS.length; index++) {
            const fieldName = ADDRESS_FIELDS[index];
            const rules = (validationRules[fieldName as keyof typeof validationRules] || []) as { type: string }[];

            if (rules?.some((rule: { type: string }) => validationMethods[rule.type](rule)(values[fieldName]))) {
                return [t('addressSelect-required')];
            }

            if (
                Object.keys(customFieldValidation).includes(fieldName)
                && customFieldValidation[fieldName as keyof typeof customFieldValidation](values[fieldName])
            ) {
                return [t('addressSelect.blocked')];
            }
        }
    }, [checkCities, checkZips, t]);
};
